import * as S from './styled';

const Textarea = ({ ...props }) => <S.Textarea {...props} />;

export default Textarea;
